<template>
    <div class="dispositivos">
        <p>Hemos detectado que reproduces contenido en varios dispositivos, debes deshabilitar la reproducción en
        uno de ellos para poder continuar.</p>
        <table class="table table-dark">
            <thead>
            <tr>
                <th colspan="2">Usuarios</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="dispositivo in dispositivos"
                :key="dispositivo.id">
                <td>
                    {{ dispositivo.user_agent.device  }} / {{ dispositivo.user_agent.platform  }} / {{ dispositivo.user_agent.browser  }}<br/>
                    <small>hace {{ format(dispositivo.update_date) }}</small>
                </td>
                <td class="text-right">
                    <button class="btn" @click="deshabilitar(dispositivo)">Desconectar</button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { format, toDate, formatDistance } from "date-fns";
import { es } from "date-fns/esm/locale";

export default {
	name: "dispositivos",
	props: ["dispositivos"],
	data() {
		return {};
	},
	methods: {
		deshabilitar(dispositivo) {
			this.$emit("deshabilitar", dispositivo);
		},
		format(date) {
			return formatDistance(toDate(date), new Date(), {
				locale: es
			});
		}
	}
};
</script>
